import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import ActionButton from '../../../Button/ActionButton';
import LayoutWithList from '../../../LayoutModal/WithList';
import Loading from "../../../Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interfaces
import { Inputs } from 'Interfaces/IAgreement';
import { ICreate } from 'Interfaces/ICreate';
export default function Update({
    isOpenModal,
    setModalClose,
    selectedUrlId,
    refreshFrames,
    setToastData,
    setToastOpen
}: ICreate) {

    const {
        register,
        handleSubmit: handleFormSubmit,
        setValue,
        formState: { errors },
    } = useForm<Inputs>();

    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`agreement/${selectedUrlId}`);
            const addressData = response.data;
            for (const key in addressData) {
                setValue(key as keyof Inputs, addressData[key]);
            }

        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    useEffect(() => {
        if (isOpenModal && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModal, selectedUrlId]);

    //Formatar dados para MAIÚSCULA
    const toUpperCaseStrings = (obj: Record<string, any>) => {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.toUpperCase() : value,
            ])
        );
    };

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            const payload = toUpperCaseStrings(data);
            const response = await apiRequest<Inputs>(`agreement/${selectedUrlId}`, 'PATCH', payload);
            const status = response.status;
            if (status === 200) {
                setToastData({
                    status: status,
                    message: 'Cadastrado com sucesso!',
                });

                setToastOpen(true);
                refreshFrames();
                setModalClose();
            }
        } catch (error: any) {
            setToastData({
                status: error?.response?.status || 500,
                message: error.message || 'Erro inesperado',
            });

            setToastOpen(true);
        }
    };

    if (isOpenModal) {
        return (
            <LayoutWithList
                title='Editar Convênio'
                subTitle='Atualize as informações do convênio em sua base de dados.'
                setModalClose={setModalClose}
            >
                <S.Container>
                    {
                        isLoading ? (
                            <Loading />
                        ) :
                            <S.SeparateDiv>
                                <S.FormInput>
                                    <S.Label>
                                        Nome do convênio
                                        <span>*</span>
                                    </S.Label>
                                    <S.Input placeholder='Informe o nome do convênio' type='text' {...register("agreement", { required: true })} />
                                    {errors.agreement && <S.InforErro>Campo Obrigatório</S.InforErro>}
                                </S.FormInput>

                                <S.ContentButton>
                                    <ActionButton name='Atualizar' onClick={handleFormSubmit(onSubmit)} />
                                </S.ContentButton>
                            </S.SeparateDiv>
                    }
                </S.Container>
            </LayoutWithList>
        )
    } return null
}